import { z } from 'zod';

import { Product, ProductSchema } from './product';
import { ElementType } from './utils';
import {
  Enum_Modules_Type,
  StoryModuleFragment,
} from '../graphql/generated/graphql';
import { ValidationError } from '../utils/errors';

export const StoryComponentSchema = z.object({
  __typename: z.literal('ComponentContentStory'),
  Story: z
    .object({
      id: z.string(),
      Status: z.string(),
    })
    .passthrough(),
});

export type StoryComponent = ElementType<
  StoryModuleFragment['Content'] & {
    __typename: 'ComponentContentStory';
  }
> &
  z.infer<typeof StoryComponentSchema>;

export const StoryModuleSchema = z
  .object({
    __typename: z.literal('Modules'),
    Type: z.literal(Enum_Modules_Type.Stories),
    Product: ProductSchema,
    Content: StoryComponentSchema.array().nonempty(),
  })
  .passthrough();

type StoryModuleSchema = z.infer<typeof StoryModuleSchema>;

export type StoryModule = Omit<StoryModuleFragment, 'Content' | 'Product'> & {
  Content: StoryComponent[];
  Product: Product;
} & z.infer<typeof StoryModuleSchema>;

export const isStoryModule = (
  value: unknown,
  strict = true
): value is StoryModule => {
  const result = StoryModuleSchema.safeParse(value);
  if (strict && !result.success) {
    throw new ValidationError(
      `Invalid story module: ${JSON.stringify(value)}` +
        '\n' +
        `Issues: ${JSON.stringify(result.error.issues)}`
    );
  }
  return result.success;
};
